import React from 'react'
import { Link } from 'react-router-dom'
import { useMsal } from '@azure/msal-react'
import { loginRequest, isConfigPlaceholder } from '../auth/msalConfig'

const SignIn: React.FC = () => {
    const { instance, accounts, inProgress } = useMsal()
    const account = instance.getActiveAccount() || accounts[0]

    const handleSignIn = () => {
        instance
            .loginRedirect({
                ...loginRequest,
                prompt: 'login',
            })
            .catch(err => console.error(err))
    }

    const handleSignOut = () => {
        instance.logoutRedirect().catch(err => console.error(err))
    }

    return (
        <div className="sign-in">
            <h1 className="sign-in__title">{account ? 'You are signed in' : 'Sign In'}</h1>

            {!account && (
                <>
                    <p className="sign-in__info">
                        <strong>Already have a MyAccount? Click the Sign in button below to access your account.</strong>
                        <br />If this is your first time using the new MyAccount platform, you'll be taken to a secure authentication page, so the web address will look different - this is completely normal and part of keeping your account safe. You will also be asked to reset your password after signing in.
                    </p>
                    <button className="btn btn-primary sign-in__button" onClick={handleSignIn}>
                        Sign in to your account
                    </button>
                    <p className="sign-in__info">
                        <strong>New to MyAccount?</strong><br /><Link to="/register">Register for an account here</Link> by completing the form.
                    </p>
                    <p className="sign-in__info">
                        <strong>Need to update your email?</strong><br />If you already have a MyAccount and want to change the email you use to sign in, <a href="https://www.accentgroup.org/your-home/myaccount/register/" target="_blank" rel="noopener noreferrer">complete this form</a>.
                    </p>
                </>
            )}

            {inProgress !== 'none' && !account && (
                <div className="alert alert-info" role="status">
                    Completing authentication... ({inProgress})
                </div>
            )}

            {account && (
                <div className="sign-in__welcome">
                    <p>Welcome, {account.name || account.username}!</p>
                    <button className="btn btn-outline-danger" onClick={handleSignOut}>
                        Sign out
                    </button>
                </div>
            )}

            {isConfigPlaceholder() && (
                <div className="alert alert-warning" role="alert">
                    MSAL config still uses placeholder values. Update clientId / authority (see src/auth/msalConfig.ts).
                </div>
            )}
        </div>
    )
}

export default SignIn
